import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `edit:` scope (F67 `/edit/:docId` route),
 * following the exact `documents:`/`editor:` precedent — NOT a second i18n
 * runtime (E18/§13.3 ban), just physically scoped here because
 * `packages/i18n/**` is outside this task's ownership boundary.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/edit.json`.
 */
const en = {
  'notFound.title': 'We couldn’t find this document.',
  'notFound.cta': 'Back to documents',
  'error.title': 'Couldn’t load the editor.',
  'error.retry': 'Retry',
  'chapters.breadcrumb': 'Documents',
  // mockup-20 (design/app/20-editor.html): "OUTLINE · 8 CHAPTERS" eyebrow —
  // `.treeTitle` already applies text-transform:uppercase, so the raw string
  // only needs the mixed-case words + ICU count plural.
  'chapters.title': 'Outline · {count, plural, one {# chapter} other {# chapters}}',
  'chapters.empty': 'This document has no chapters yet.',
  'enhance.title': 'Enhance',
  'versions.toggle': 'Version history',
  'status.draft': 'Draft',
  'status.generating': 'Generating',
  'status.ready': 'Ready',
  'status.failed': 'Failed',
  'action.read': 'Read',
  'action.share': 'Share',
  'action.style': 'Themes & styling',
} as const;

const ro: Record<keyof typeof en, string> = {
  'notFound.title': 'Nu am găsit acest document.',
  'notFound.cta': 'Înapoi la documente',
  'error.title': 'Nu am putut încărca editorul.',
  'error.retry': 'Reîncearcă',
  'chapters.breadcrumb': 'Documente',
  'chapters.title': 'Schiță · {count, plural, one {# capitol} other {# capitole}}',
  'chapters.empty': 'Acest document nu are încă niciun capitol.',
  'enhance.title': 'Îmbunătățește',
  'versions.toggle': 'Istoric versiuni',
  'status.draft': 'Ciornă',
  'status.generating': 'Se generează',
  'status.ready': 'Gata',
  'status.failed': 'Eșuat',
  'action.read': 'Citește',
  'action.share': 'Distribuie',
  'action.style': 'Teme și stilizare',
};

export const EDIT_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type EditCatalogKey = keyof typeof en;
